import { render, staticRenderFns } from "./Dissertation.vue?vue&type=template&id=aabfc28c&scoped=true&"
import script from "./Dissertation.vue?vue&type=script&lang=js&"
export * from "./Dissertation.vue?vue&type=script&lang=js&"
import style0 from "./Dissertation.vue?vue&type=style&index=0&id=aabfc28c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aabfc28c",
  null
  
)

export default component.exports